__turbopack_context__.v({
  "dateAndLabel": "shipping-checkpoints-module__s6SFba__dateAndLabel",
  "shippingBlock": "shipping-checkpoints-module__s6SFba__shippingBlock",
  "shippingCheckpoints": "shipping-checkpoints-module__s6SFba__shippingCheckpoints",
  "shippingCutoff": "shipping-checkpoints-module__s6SFba__shippingCutoff",
  "shippingStep": "shipping-checkpoints-module__s6SFba__shippingStep",
  "shippingStepDate": "shipping-checkpoints-module__s6SFba__shippingStepDate",
  "shippingStepIcon": "shipping-checkpoints-module__s6SFba__shippingStepIcon",
  "shippingStepLabel": "shipping-checkpoints-module__s6SFba__shippingStepLabel",
  "shippingTextIcon": "shipping-checkpoints-module__s6SFba__shippingTextIcon",
  "shippingTextItem": "shipping-checkpoints-module__s6SFba__shippingTextItem",
  "shippingTexts": "shipping-checkpoints-module__s6SFba__shippingTexts",
});
